import { Box, BoxProps, useTheme } from '@mui/material';

interface IAppCardProps extends Omit<BoxProps, 'onClick'> {
  interactive?: boolean;
  onClick?: () => void;
}

// Superfície-base do Design System TORQ — contraste de superfície + borda,
// sem sombra (guia seção 30). Usar no lugar de `Card`/`Paper` avulsos quando
// o resultado precisa se adaptar a light/dark automaticamente.
export const AppCard: React.FC<IAppCardProps> = ({ interactive = false, onClick, sx, children, ...rest }) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: theme.torq.surface.card,
        border: `1px solid ${theme.torq.border.default}`,
        borderRadius: `${theme.shape.borderRadius}px`,
        cursor: interactive || onClick ? 'pointer' : 'default',
        transition: 'transform 150ms ease, border-color 150ms ease',
        ...(interactive || onClick
          ? { '&:hover': { transform: 'translateY(-1px)', borderColor: theme.torq.border.strong } }
          : {}),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
